import { render, staticRenderFns } from "./religious.vue?vue&type=template&id=1e5b3ad8"
import script from "./religious.vue?vue&type=script&lang=js"
export * from "./religious.vue?vue&type=script&lang=js"
import style0 from "./religious.vue?vue&type=style&index=0&id=1e5b3ad8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports